import { models, kea, fa } from "app/main/std";

type Entity = models.UsuarioApiDto;
type Column = kea.Grid2Column<Entity>;

const columnasFijas: Column[] = [
    {title: "Nombre", cell:x => ({data: x.Nombre})},
    {title: "Cliente", cell:x => ({data: x.NombreCliente})},
    
    {title: "Contenido paquete (default)", cell:x => ({data: x.NombreContenidoPaquete})},
    {title: "Descripción paquete (default)", cell:x => ({data: x.NombreDescripcionPaquete})},
    {title: "Contenido sobre (default)", cell:x => ({data: x.NombreContenidoSobre})},
]

export interface BotonesDeps {
    onBorrar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Editar",
            style: "primary",
            iconClass: fa("pencil"),
            onClick: deps.onEdit
        },
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onBorrar
        }
    ]);

    return columna;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/list/columns.tsx